export const APP_BADGE_MAX = 99;

const badgeNavigator = () => (typeof navigator === 'undefined' ? null : navigator);

export const syncAppBadge = (count) => {
  const badgeApi = badgeNavigator();
  if (!badgeApi) return Promise.resolve();

  const value = Number(count);
  if (!Number.isFinite(value) || value < 1) {
    if (typeof badgeApi.clearAppBadge !== 'function') return Promise.resolve();
    return Promise.resolve(badgeApi.clearAppBadge()).catch(() => {});
  }

  if (typeof badgeApi.setAppBadge !== 'function') return Promise.resolve();
  return Promise.resolve(badgeApi.setAppBadge(Math.min(Math.floor(value), APP_BADGE_MAX))).catch(() => {});
};
